/** Vandaag pagina — geeft TodayView weer met echte data uit useTasksContext. */
import TodayView from '@/features/today/components/TodayView';

const TodayPage = () => <TodayView />;

export default TodayPage;
